<section class="container">
    <div class="column-content">
        <form [formGroup]="identificatorForm" #identificatorFormRef="ngForm" (ngSubmit)="onSubmitIdentificatorForm()">
            <div class="row-content">
                <mat-form-field class="custom-width">
                    <mat-label>{{ 'businessTexts.email' | translate }} </mat-label>
                    <input matInput formControlName="email" type="email">
                    <mat-error *ngIf="identificatorForm.get('email')?.hasError('required')">
                        {{'businessTexts.emailRequired' | translate }}
                    </mat-error>
                
                    <mat-error *ngIf="identificatorForm.get('email')?.hasError('email')">
                        {{'businessTexts.invalidEmail' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="custom-width">
                    <mat-label>{{ 'businessTexts.phone' | translate }} </mat-label>
                    <input matInput formControlName="phone" type="tel">
                    <mat-error *ngIf="identificatorForm.get('phone')?.hasError('required')">
                        {{'businessTexts.phoneRequired' | translate }}
                    </mat-error>
                    <mat-error *ngIf="identificatorForm.get('phone')?.hasError('pattern')" class="text-error-phone">
                        {{'businessTexts.phoneValidatorError' | translate}}
                    </mat-error>
                </mat-form-field>
                <button mat-raised-button type="submit"
                    [disabled]="identificatorForm.invalid || isSubmitting">{{'businessTexts.send' | translate}}</button>
            </div>
        </form>
    </div>
    <div class="notis">
        <cqes-icon icon="info" class="text-success row-status-identification"></cqes-icon>
        <span>{{'businessTexts.infoAfterIdentification' | translate}}</span>
    </div>
    <div class="title-table">{{'businessTexts.sendOneTime' | translate}} </div>
    <div class="message" *ngIf="!hasData() && !isLoading">
        {{'historyTexts.noDocumentsFound' | translate}}
    </div>
    <div class="data-container" [hidden]="!hasData() || isLoading">
        <div class="mat-elevation-z8 table-content">
            <mat-table [dataSource]="idintificatorDataSource" matSort matSortActive="requestNumber"
                matSortDirection="desc" multiTemplateDataRows>
                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef="let status">
                        <div class="status-head"> {{'businessTexts.identificationTable.status' | translate}}
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div class="cell">
                            <div
                                matTooltip="{{isItDanger(row).tooltip}}">
                                <cqes-icon icon="{{isItDanger(row).icon}}" class="text-{{isItDanger(row).iconType}} row-status-identification {{isItDanger(row).isFilled ? 'cqes-icon-filled' : 'cqes-icon-outlined'}}"></cqes-icon>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email">
                    <mat-header-cell mat-sort-header #email id="email" *matHeaderCellDef="let email">
                        {{'businessTexts.email' | translate}}

                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div class="cell">
                            {{row.email}}
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell mat-sort-header #phone id="phoneNumber" *matHeaderCellDef="let phoneNumber">
                        {{'businessTexts.phone' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row?.phoneNumber}}

                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                    <mat-header-cell mat-sort-header id="createdAt" *matHeaderCellDef="let createdAt">
                        {{'businessTexts.createdAt' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div class="cell">
                            {{row.createdAt | date:'dd.MM.yyyy HH:mm' : currentLocale}}
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <mat-header-cell class="header-align-right" *matHeaderCellDef>
                        {{ 'businessTexts.identificationTable.actions' | translate }}
                    </mat-header-cell>

                    <mat-cell *matCellDef="let row">
                        <ng-container
                            *ngIf="isItDanger(row).busnessIdentificationHamburger?.length > 0">
                            <span [matMenuTriggerFor]="docs" class="action">
                                <button mat-icon-button color="primary">
                                    <cqes-icon icon="menu"></cqes-icon>
                                </button>
                            </span>

                            <mat-menu #docs="matMenu">
                                <div>
                                    <button mat-menu-item
                                        (click)="downloadUEISIGN(row)"
                                        *ngIf="isItDanger(row).busnessIdentificationHamburger?.includes('downloadUEISIGN')">
                                        <cqes-icon icon="settings"></cqes-icon>
                                        {{'businessTexts.downloadUEI' | translate}}
                                    </button>
                                    <button mat-menu-item
                                        (click)="downloadUEICREATE(row)"
                                        *ngIf="isItDanger(row).busnessIdentificationHamburger?.includes('downloadUEICREATE')">
                                        <cqes-icon icon="settings"></cqes-icon>
                                        {{'businessTexts.downloadUEI' | translate}}
                                    </button>
                                    <button mat-menu-item
                                        (click)="downloadUEIJSON(row)"
                                        *ngIf="isItDanger(row).busnessIdentificationHamburger?.includes('downloadUEIJSON')">
                                        <cqes-icon icon="settings"></cqes-icon>
                                        {{'businessTexts.downloadUEIJSON' | translate}}
                                    </button>
                                    <button mat-menu-item
                                         *ngIf="isItDanger(row).busnessIdentificationHamburger?.includes('sendDocOTC')"
                                        (click)="viewUser(row)">
                                        <cqes-icon icon="settings"></cqes-icon>
                                        {{'businessTexts.webIdentificationTable.sendDocOTC' | translate}}
                                    </button>
                                </div>
                            </mat-menu>
                        </ng-container>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" class="expand-element-row">
                </mat-row>
            </mat-table>
        </div>
    </div>
</section>